module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500.woff?87284894879f5b1c229cb49c8ff6decc";